import { Component, inject, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@auth0/auth0-angular';
import { SHARED_ENVIRONMENT_CONFIG } from '../../config/environment.token';
import { UserMenuItem } from '../../models/UserMenuItem';
import { Router } from '@angular/router';
import {
  PopoverAnchorDirective,
  PopoverBodyTemplateDirective,
  PopoverComponent,
  PopoverTitleTemplateDirective,
} from '@progress/kendo-angular-tooltip';
import { AsyncPipe } from '@angular/common';
import { CapitalizePipe } from '../../pipes';
import { signOut } from '../../utils/signed-out-utils/sign-out';

@Component({
  selector: 'rc-user-profile-settings',
  standalone: true,
  templateUrl: './user-profile-settings.component.html',
  styleUrl: './user-profile-settings.component.scss',
  imports: [
    TranslateModule,
    PopoverAnchorDirective,
    PopoverComponent,
    AsyncPipe,
    PopoverTitleTemplateDirective,
    PopoverBodyTemplateDirective,
    CapitalizePipe,
  ],
})
export class UserProfileSettingsComponent {
  authService = inject(AuthService);
  environment = inject(SHARED_ENVIRONMENT_CONFIG);
  #router = inject(Router);
  readonly menuAnchor = viewChild(PopoverAnchorDirective);
  menuItems: UserMenuItem[] = [
    {
      text: 'LOGOUT',
      clickAction: () => this.logout(),
      icon: 'rc-icon-logout',
    },
    {
      text: 'SETTINGS',
      clickAction: () => this.navigateToSettings(),
      icon: 'rc-icon-settings',
    },
  ];

  logout() {
    signOut(this.authService, this.environment.auth0.clientId);
  }

  navigateToSettings() {
    this.#router.navigate(['/users/settings']);
    this.menuAnchor()?.hide();
  }
}
